import { ENABLE_I18N } from '@src/config/env'
import { TCountry } from '@src/config/i18n.config'
import { I18N_PREVIEW_KEY } from '@src/constants/i18n.constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export const isCountryCanada = (country: TCountry) => country.toLowerCase() === 'ca'
export const isCountryUS = (country: TCountry) => country.toLowerCase() === 'us'

export const getBFFApiVersion = (isI18nPreviewEnabled: boolean, apiVersion?: string) => {
  if (apiVersion === 'v3') {
    return 'v3'
  }
  if (isI18nPreviewEnabled) {
    return 'v2'
  } else {
    return 'v1'
  }
}

export function shouldEnableI18nServer(): boolean {
  return ENABLE_I18N
}

export function shouldEnableI18nClient(): boolean {
  if (!isBrowser() || !ENABLE_I18N) return false
  const isI18nDropdownEnabled = getCookie(I18N_PREVIEW_KEY) === 'true'
  return isI18nDropdownEnabled
}
